import React, { Component } from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../context/WithConsumer';


export default class ModText extends Component {
    render () {
	    let block = this.props.block;
	    return (
	        <div className={'l-block l-block--display-' + block.display + ' scope-' + block.text_color} style={{backgroundColor: block.block_color}}>
	        	
	        	<div className="l-grid">
	        		{block.layout == 'twocols' &&
		        		<>
				        	<div className="l-grid__col l-grid__col--m-6-12">
				        		<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
						        	{block.heading &&
							        	<h2 className="c-heading c-heading--large c-heading--large-space">{ block.heading }</h2>
						        	}
					        	</ScrollAnimation>
				        	</div>
				        	<div className="l-grid__col l-grid__col--m-6-12">
				        		<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
						        	{block.text &&
							        	<div className={"scope-text scope-text--" + block.text_size} dangerouslySetInnerHTML={ {__html: block.text } }></div>
						        	}
					        	</ScrollAnimation>
				        	</div>
			        	</>
		        	}
		        	{block.layout == 'article' &&
		        		<>
				        	<div className="l-grid__col l-grid__col--m-6-12">
				        		<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
						        	{block.heading &&
							        	<h2 className="c-heading c-heading--large c-heading--large-space">{ block.heading }</h2>
						        	}
					        	</ScrollAnimation>
				        	</div>
				        	<div className="l-grid__col l-grid__col--m-6-12">
				        		<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
						        	{block.text &&
							        	<div className={"scope-text scope-text--article"} dangerouslySetInnerHTML={ {__html: block.text } }></div>
						        	}
					        	</ScrollAnimation>
				        	</div>
			        	</>
		        	}
		        	{block.layout == 'onecolleft' &&
			        	<div className="l-grid__col l-grid__col--m-6-12">
			        		<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
			        			{block.heading &&
						        	<h2 className="c-heading c-heading c-heading--space">{ block.heading }</h2>
					        	}
					        	{block.text &&
						        	<div className={"scope-text scope-text--" + block.text_size} dangerouslySetInnerHTML={ {__html: block.text } }></div>
					        	}
				        	</ScrollAnimation>
			        	</div>
		        	}
		        	{block.layout == 'onecolright' &&
			        	<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--m-push-6-12">
			        		<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
			        			{block.heading &&
						        	<h2 className="c-heading c-heading c-heading--space">{ block.heading }</h2>
					        	}
					        	{block.text &&
						        	<div className={"scope-text scope-text--" + block.text_size} dangerouslySetInnerHTML={ {__html: block.text } }></div>
					        	}
				        	</ScrollAnimation>
			        	</div>
		        	}
		        </div>
	        
			</div>
		)
	};
};
